import { extendTheme } from '@chakra-ui/react'
const theme = {
  colors: {
    primary: 'purple',
  },
}

export default extendTheme(theme)
